module.exports = __webpack_public_path__ + "img/logo-ovo_qris-inactive.95d7081b.svg";